import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      login: 'LOGIN',
      logout: 'LOGOUT',
      welcome: 'WELCOME',

      // Auth
      signUp: 'SIGN UP',
      loginTitle: 'LOGIN',
      signUpTitle: 'SIGN UP',
      accessAccount: 'Access your account',
      createAccount: 'Create your account',
      fullName: 'FULL NAME',
      firstName: 'FIRST NAME',
      lastName: 'LAST NAME',
      birthdate: 'BIRTHDATE',
      email: 'EMAIL',
      password: 'PASSWORD',
      yourName: 'Your name',
      yourFirstName: 'Your first name',
      yourLastName: 'Your last name',
      yourEmail: 'your@email.com',
      passwordPlaceholder: '••••••••',
      loading: 'LOADING...',
      loginBtn: 'LOGIN',
      signUpBtn: 'SIGN UP',
      noAccount: "Don't have an account? Sign up",
      haveAccount: 'Already have an account? Login',
      welcomeBack: 'Welcome back!',
      loginSuccess: 'You have successfully logged in.',
      accountCreated: 'Account created!',
      checkEmail: 'Please check your email to verify your account.',

      // Footer
      services: 'SERVICES',
      company: 'COMPANY',
      support: 'SUPPORT',
      followUs: 'FOLLOW US',
      hair: 'Hair',
      nails: 'Nails',
      skin: 'Skin',
      massage: 'Massage',
      tattoo: 'Tattoo',
      piercing: 'Piercing',
      aboutUs: 'About Us',
      careers: 'Careers',
      blog: 'Blog',
      press: 'Press',
      contact: 'Contact',
      faqs: 'FAQs',
      privacy: 'Privacy',
      terms: 'Terms',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      cookiePolicy: 'Cookie Policy',
      copyright: '© 2025 Zavira Salon & Spa. All rights reserved.',

      // Other common
      bookAppointment: 'BOOK APPOINTMENT',
      reserveExperience: 'Reserve your luxurious experience',
      ourServices: 'Our Services',
      experienceLuxury: 'Experience luxury and excellence',
      viewAllServices: 'View All Services',
      browseServices: 'Browse Services',
      // Services
      hairStyling: 'Hair Styling',
      hairStylingDesc: 'Premium cuts, coloring, and treatments',
      nailCare: 'Nail Care',
      nailCareDesc: 'Manicures, pedicures, and nail art',
      skincare: 'Skincare',
      skincareDesc: 'Facials, treatments, and rejuvenation',
      massageService: 'Massage',
      massageDesc: 'Relaxation and therapeutic massage',
      tattooService: 'Tattoo',
      tattooDesc: 'Custom artwork and body art',
      piercingService: 'Piercing',
      piercingDesc: 'Professional piercing services',

      // Products
      luxuryHairSerum: 'Luxury Hair Serum',
      premiumFaceCream: 'Premium Face Cream',
      nailPolishSet: 'Nail Polish Set',
      hydratingShampoo: 'Hydrating Shampoo',
      antiAgingSerum: 'Anti-Aging Serum',
      makeupBrushSet: 'Makeup Brush Set',
      hairCare: 'Hair Care',
      skinCare: 'Skin Care',
      nailCareCategory: 'Nail Care',
      makeup: 'Makeup',

      // Reviews section
      whatOurClientsSay: 'What Our Clients Say',
      testimonialsFromGuests: 'Testimonials from our valued guests',

      // Review texts
      reviewSarah: 'Absolutely stunning experience! The attention to detail is unmatched.',
      reviewMichael: 'Best salon in town. The staff is professional and the ambiance is luxurious.',
      reviewEmma: 'I feel like royalty every time I visit. Highly recommend!',
      reviewDavid: 'Exceptional service and results. Worth every penny!',
      reviewSophie: 'The spa treatments are heavenly. A true escape from daily life.',

      // Booking
      bookAppointmentTitle: 'BOOK APPOINTMENT',
      selectService: 'SELECT SERVICE',
      selectStylist: 'SELECT STYLIST',
      selectDateTime: 'SELECT DATE & TIME',
      contactInfo: 'CONTACT INFO',
      confirmBooking: 'CONFIRM BOOKING',
      availableTimeSlots: 'AVAILABLE TIME SLOTS',
      specialRequests: 'SPECIAL REQUESTS',
      bookingSummary: 'Booking Summary',
      payment: 'Payment',
      payWithCard: 'Or pay with card during your visit',
      bookingConfirmed: 'Booking confirmed!',
      bookingSuccessGuest: 'Your appointment has been scheduled. We\'ll contact you soon to confirm details.',
      bookingSuccessUser: 'Your appointment has been scheduled successfully.',
      error: 'Error',
      fillRequiredFields: 'Please fill in all required fields.',
      phoneNumber: 'PHONE NUMBER',
      location: 'LOCATION',
      fullNameLabel: 'FULL NAME',
      emailOptional: 'EMAIL (Optional)',
      emailRequired: 'EMAIL',
      phoneOptional: 'PHONE (Optional)',
      downtownSalon: 'Downtown Salon',
      uptownSpa: 'Uptown Spa',
      westsideStudio: 'Westside Studio',
      eastsideLounge: 'Eastside Lounge',
      airportLocation: 'Airport Location',
      service: 'Service:',
      stylist: 'Stylist:',
      date: 'Date:',
      time: 'Time:',
      name: 'Name:',
      phone: 'Phone:',
      locationLabel: 'Location:',
      previous: 'Previous',
      next: 'Next',
      confirmBookingBtn: 'CONFIRM BOOKING',
      bookingInProgress: 'BOOKING...',

      // AI Recommendations
      recommendedForYou: 'Recommended for You',
      basedOnPreferences: 'Based on your preferences and booking history',
      whyRecommended: 'Why recommended',
      bookNow: 'Book Now',
      viewDetails: 'View Details',

      // Calendar Sync
      syncToCalendar: 'Sync to Calendar',
      addToGoogleCalendar: 'Add to Google Calendar',
      addToOutlook: 'Add to Outlook',
      calendarSyncSuccess: 'Appointment added to your calendar!',
      calendarSyncError: 'Failed to add to calendar. Please try manually.',

      // Real-time updates
      liveAvailability: 'Live Availability',
      updating: 'Updating...',
      slotsAvailable: 'slots available',
      fullyBooked: 'Fully booked',
      lastUpdated: 'Last updated',
      justNow: 'just now',
      minutesAgo: 'minutes ago',

      // About Page
      aboutUsTitle: 'ABOUT US',
      aboutSubtitle: 'Where luxury meets excellence',
      ourStory: 'Our Story',
      ourStoryText: 'Founded in 2020, Zavira Salon & Spa has become the premier destination for luxury beauty and wellness treatments. Our commitment to excellence and attention to detail has made us the choice of discerning clients who seek nothing but the best.',
      ourPhilosophy: 'Our Philosophy',
      ourPhilosophyText: 'We believe that beauty is an art form, and every client deserves a personalized experience. Our team of expert stylists and therapists are passionate about bringing out your natural beauty while providing a sanctuary for relaxation and rejuvenation.',
      whyChooseUs: 'Why Choose Us',
      whyChooseUs1: 'World-class professionals with years of experience',
      whyChooseUs2: 'Premium products from leading luxury brands',
      whyChooseUs3: 'State-of-the-art facilities in an elegant setting',
      whyChooseUs4: 'Personalized service tailored to your needs',

      // Team Page
      ourTeam: 'Our Team',
      teamSubtitle: 'Meet the talented artists and specialists who bring your beauty vision to life',
      joinOurTeam: 'Join Our Team',
      joinOurTeamText: 'Are you passionate about beauty and excellence? We\'re always looking for talented individuals to join our family.',
      viewOpenPositions: 'View Open Positions',
      teamUpdating: 'Our team information is being updated. Check back soon!',
      unableToLoadTeam: 'Unable to load team members',
      leadStylist: 'Lead Stylist & Manager',
      seniorSpecialist: 'Senior Specialist',
      specialist: 'Specialist',
      manager: 'Manager',
      teamMember: 'Team Member',

      // Contact Page
      contactUsTitle: 'CONTACT US',
      contactSubtitle: 'Get in touch with our team',
      sendUsMessage: 'Send us a message',
      nameLabel: 'NAME',
      yourNamePlaceholder: 'Your name',
      emailLabel: 'EMAIL',
      emailPlaceholder: 'your@email.com',
      messageLabel: 'MESSAGE',
      messagePlaceholder: 'How can we help you?',
      sendMessage: 'SEND MESSAGE',
      addressLabel: 'Address',
      phoneLabel: 'Phone',
      hoursLabel: 'Hours',
      businessHours: 'Daily: 10:00 AM - 11:00 PM',

      // Services Browsing
      browseServicesHeading: 'BROWSE SERVICES',
      browseServicesSubtitle: 'Premium beauty services for home care',
      searchProducts: 'Search for products...',
      allCategories: 'All',
      hairCareCategory: 'Hair Care',
      skinCareCategory: 'Skin Care',
      nailCareShop: 'Nail Care',
      makeupCategory: 'Makeup',
      toolsCategory: 'Tools',
      bodyCareCategory: 'Body Care',
      noProductsFound: 'No products found',
      tryDifferentSearch: 'Try a different category or search term',
      featured: 'Featured',
      lowStock: 'Low Stock',
      inStock: 'In Stock',
      leftInStock: 'left',
      addToCart: 'Add to Cart',
      outOfStock: 'Out of Stock',
      addedToCart: 'Added to cart',
      addedToCartDesc: 'has been added to your cart.',
      removedFromWishlist: 'Removed from wishlist',
      addedToWishlist: 'Added to wishlist',
      productRemovedWishlist: 'Product has been removed from your wishlist.',
      productAddedWishlist: 'Product has been added to your wishlist.',
      loadingProducts: 'Loading products...',
      customerReviews: 'Customer Reviews',
      noReviewsYet: 'No reviews yet. Be the first to review!',
      verified: 'Verified',
      foundHelpful: 'found this helpful',
      ingredients: 'Ingredients',
      howToUse: 'How to Use',
      reviews: 'reviews',
      noProductsForSearch: 'No products found for',
      sizeLabel: 'Size:',
      skuLabel: 'SKU:',
      failedToLoadProducts: 'Failed to load products',

      // Blog Page
      blogTitle: 'BLOG',
      blogSubtitle: 'Beauty insights and expert advice',
      noBlogPosts: 'No blog posts found in this category.',
      byAuthor: 'By',

      // VideoHero
      exploreServices: 'Explore Services',
      professionalBeautyServices: 'Professional beauty services in an elegant atmosphere',

      // Services Page
      servicesTitle: 'SERVICES',
      servicesSubtitle: 'Indulge in our curated selection of luxury treatments',
      searchServicesPlaceholder: 'Search services... (e.g., \'relaxing massage\' or \'hair color\')',
      noServicesFound: 'No services found matching',
      tryDifferentTerm: 'Try a different search term',
      preview: 'Preview',
      seeTransformation: 'See the transformation',
      beforeTreatment: 'Before Treatment',
      afterTreatment: 'After Treatment',
      bookThisService: 'Book This Service',
      minutes: 'minutes',

      // AnimatedMenu (Hormozi-optimized: value-driven, action-oriented, benefit-focused)
      menuServices: 'BROWSE SERVICES',
      menuPackages: 'SPECIAL OFFERS',
      menuBooking: 'BOOK NOW',
      menuMyAppointments: 'MY BOOKINGS',
      menuMembership: 'VIP MEMBERSHIP',
      menuShop: 'BROWSE SERVICES',
      menuBlog: 'BEAUTY TIPS',
      menuCareers: 'JOIN OUR TEAM',
      menuReferrals: 'EARN REWARDS',
      menuAbout: 'OUR STORY',
      menuContact: 'GET IN TOUCH',
      // Menu sub-items
      hairServices: 'Hair Services',
      massageTherapy: 'Massage Therapy',
      tattooArt: 'Tattoo Art',
      allPackages: 'All Packages',
      menPackages: 'For Men',
      bridalPackages: 'For Brides',
      groupPackages: 'Groups & Parties',
      viewAllAppointments: 'View All',
      upcomingAppointments: 'Upcoming',
      membershipPlans: 'View Plans',
      memberBenefits: 'Member Benefits',
      referFriend: 'Refer a Friend',
      myRewards: 'My Rewards',
      bookAppointmentMenu: 'Book Appointment',
      groupBooking: 'Group Booking',
      beautyTools: 'Beauty Tools',
      beautyTips: 'Beauty Tips',
      styleGuides: 'Style Guides',
      productReviews: 'Product Reviews',
      currentOpenings: 'Current Openings',
      applyNow: 'Apply Now',
      ourStoryMenu: 'Our Story',
      hoursOfOperation: 'Hours of Operation',
      getDirections: 'Get Directions',
      callUs: 'Call Us',
      faq: 'FAQ',

      // Accessibility
      accessibility: 'Accessibility',
      theme: 'Theme',
      darkTheme: 'Dark',
      lightTheme: 'Light',
      systemTheme: 'System',
      highContrastTheme: 'High Contrast',
      fontSize: 'Font Size',
      small: 'Small',
      medium: 'Medium',
      large: 'Large',
      extraLarge: 'Extra Large',
      language: 'Language',
      english: 'English',
      french: 'French',
      spanish: 'Spanish',

      // Common UI
      close: 'Close',
      back: 'Back',
      menu: 'Menu',
      all: 'All',
      salonAndSpa: 'Salon and Spa',
    }
  },
  fr: {
    translation: {
      // Navigation
      login: 'CONNEXION',
      logout: 'DÉCONNEXION',
      welcome: 'BIENVENUE',

      // Auth
      signUp: 'S\'INSCRIRE',
      loginTitle: 'CONNEXION',
      signUpTitle: 'S\'INSCRIRE',
      accessAccount: 'Accédez à votre compte',
      createAccount: 'Créez votre compte',
      fullName: 'NOM COMPLET',
      firstName: 'PRÉNOM',
      lastName: 'NOM',
      birthdate: 'DATE DE NAISSANCE',
      email: 'EMAIL',
      password: 'MOT DE PASSE',
      yourName: 'Votre nom',
      yourFirstName: 'Votre prénom',
      yourLastName: 'Votre nom',
      yourEmail: 'votre@email.com',
      passwordPlaceholder: '••••••••',
      loading: 'CHARGEMENT...',
      loginBtn: 'SE CONNECTER',
      signUpBtn: 'S\'INSCRIRE',
      noAccount: 'Pas de compte ? S\'inscrire',
      haveAccount: 'Déjà un compte ? Se connecter',
      welcomeBack: 'Bienvenue !',
      loginSuccess: 'Vous vous êtes connecté avec succès.',
      accountCreated: 'Compte créé !',
      checkEmail: 'Veuillez vérifier votre email pour vérifier votre compte.',

      // Footer
      services: 'SERVICES',
      company: 'ENTREPRISE',
      support: 'SUPPORT',
      followUs: 'SUIVEZ-NOUS',
      hair: 'Cheveux',
      nails: 'Ongles',
      skin: 'Peau',
      massage: 'Massage',
      tattoo: 'Tatouage',
      piercing: 'Piercing',
      aboutUs: 'À propos',
      careers: 'Carrières',
      blog: 'Blog',
      press: 'Presse',
      contact: 'Contact',
      faqs: 'FAQ',
      privacy: 'Confidentialité',
      terms: 'Conditions',
      privacyPolicy: 'Politique de confidentialité',
      termsOfService: 'Conditions d\'utilisation',
      cookiePolicy: 'Politique de cookies',
      copyright: '© 2025 Zavira Salon & Spa. Tous droits réservés.',

      // Other common
      bookAppointment: 'RÉSERVER UN RENDEZ-VOUS',
      reserveExperience: 'Réservez votre expérience luxueuse',
      ourServices: 'Nos Services',
      experienceLuxury: 'Découvrez le luxe et l\'excellence',
      viewAllServices: 'Voir Tous les Services',
      browseServices: 'Parcourir les services',
      // Services
      hairStyling: 'Coiffure',
      hairStylingDesc: 'Coupes premium, colorations et traitements',
      nailCare: 'Soin des Ongles',
      nailCareDesc: 'Manucures, pédicures et nail art',
      skincare: 'Soin de la Peau',
      skincareDesc: 'Soins du visage, traitements et rajeunissement',
      massageService: 'Massage',
      massageDesc: 'Massage de relaxation et thérapeutique',
      tattooService: 'Tatouage',
      tattooDesc: 'Art corporel et œuvres personnalisées',
      piercingService: 'Piercing',
      piercingDesc: 'Services de piercing professionnels',

      // Products
      luxuryHairSerum: 'Sérum Capillaire de Luxe',
      premiumFaceCream: 'Crème Visage Premium',
      nailPolishSet: 'Ensemble Vernis à Ongles',
      hydratingShampoo: 'Shampooing Hydratant',
      antiAgingSerum: 'Sérum Anti-Âge',
      makeupBrushSet: 'Ensemble Pinceaux Maquillage',
      hairCare: 'Soins Capillaires',
      skinCare: 'Soins de la Peau',
      nailCareCategory: 'Soin des Ongles',
      makeup: 'Maquillage',

      // Reviews section
      whatOurClientsSay: 'Ce Que Disent Nos Clients',
      testimonialsFromGuests: 'Témoignages de nos précieux invités',

      // Review texts
      reviewSarah: 'Expérience absolument époustouflante ! L\'attention aux détails est inégalée.',
      reviewMichael: 'Meilleur salon en ville. Le personnel est professionnel et l\'ambiance est luxueuse.',
      reviewEmma: 'Je me sens comme une reine à chaque visite. Hautement recommandé !',
      reviewDavid: 'Service et résultats exceptionnels. Ça vaut chaque centime !',
      reviewSophie: 'Les soins spa sont paradisiaques. Une véritable évasion de la vie quotidienne.',

      // Booking
      bookAppointmentTitle: 'RÉSERVER UN RENDEZ-VOUS',
      selectService: 'SÉLECTIONNER LE SERVICE',
      selectStylist: 'SÉLECTIONNER LE COIFFEUR',
      selectDateTime: 'SÉLECTIONNER DATE & HEURE',
      contactInfo: 'INFORMATIONS DE CONTACT',
      confirmBooking: 'CONFIRMER LA RÉSERVATION',
      availableTimeSlots: 'CRÉNEAUX HORAIRES DISPONIBLES',
      specialRequests: 'DEMANDES SPÉCIALES',
      bookingSummary: 'Résumé de la réservation',
      payment: 'Paiement',
      payWithCard: 'Ou payez par carte lors de votre visite',
      bookingConfirmed: 'Réservation confirmée !',
      bookingSuccessGuest: 'Votre rendez-vous a été programmé. Nous vous contacterons bientôt pour confirmer les détails.',
      bookingSuccessUser: 'Votre rendez-vous a été programmé avec succès.',
      error: 'Erreur',
      fillRequiredFields: 'Veuillez remplir tous les champs obligatoires.',
      phoneNumber: 'NUMÉRO DE TÉLÉPHONE',
      location: 'EMPLACEMENT',
      fullNameLabel: 'NOM COMPLET',
      emailOptional: 'EMAIL (Optionnel)',
      emailRequired: 'EMAIL',
      phoneOptional: 'TÉLÉPHONE (Optionnel)',
      downtownSalon: 'Salon Centre-Ville',
      uptownSpa: 'Spa Haut de la Ville',
      westsideStudio: 'Studio Ouest',
      eastsideLounge: 'Lounge Est',
      airportLocation: 'Emplacement Aéroport',
      service: 'Service :',
      stylist: 'Coiffeur :',
      date: 'Date :',
      time: 'Heure :',
      name: 'Nom :',
      phone: 'Téléphone :',
      locationLabel: 'Emplacement :',
      previous: 'Précédent',
      next: 'Suivant',
      confirmBookingBtn: 'CONFIRMER LA RÉSERVATION',
      bookingInProgress: 'RÉSERVATION...',

      // AI Recommendations
      recommendedForYou: 'Recommandé pour Vous',
      basedOnPreferences: 'Basé sur vos préférences et votre historique de réservations',
      whyRecommended: 'Pourquoi recommandé',
      bookNow: 'Réserver Maintenant',
      viewDetails: 'Voir les Détails',

      // Calendar Sync
      syncToCalendar: 'Synchroniser avec le Calendrier',
      addToGoogleCalendar: 'Ajouter à Google Calendar',
      addToOutlook: 'Ajouter à Outlook',
      calendarSyncSuccess: 'Rendez-vous ajouté à votre calendrier !',
      calendarSyncError: 'Échec de l\'ajout au calendrier. Veuillez essayer manuellement.',

      // Real-time updates
      liveAvailability: 'Disponibilité en Direct',
      updating: 'Mise à jour...',
      slotsAvailable: 'créneaux disponibles',
      fullyBooked: 'Complet',
      lastUpdated: 'Dernière mise à jour',
      justNow: 'à l\'instant',
      minutesAgo: 'minutes',

      // About Page
      aboutUsTitle: 'À PROPOS DE NOUS',
      aboutSubtitle: 'Là où le luxe rencontre l\'excellence',
      ourStory: 'Notre Histoire',
      ourStoryText: 'Fondé en 2020, Zavira Salon & Spa est devenu la destination de choix pour les soins de beauté et de bien-être de luxe. Notre engagement envers l\'excellence et notre attention aux détails ont fait de nous le choix des clients exigeants qui ne cherchent que le meilleur.',
      ourPhilosophy: 'Notre Philosophie',
      ourPhilosophyText: 'Nous croyons que la beauté est une forme d\'art, et chaque client mérite une expérience personnalisée. Notre équipe de stylistes et thérapeutes experts est passionnée par la mise en valeur de votre beauté naturelle tout en offrant un sanctuaire de détente et de rajeunissement.',
      whyChooseUs: 'Pourquoi Nous Choisir',
      whyChooseUs1: 'Professionnels de classe mondiale avec des années d\'expérience',
      whyChooseUs2: 'Produits premium des marques de luxe leaders',
      whyChooseUs3: 'Installations ultramodernes dans un cadre élégant',
      whyChooseUs4: 'Service personnalisé adapté à vos besoins',

      // Team Page
      ourTeam: 'Notre Équipe',
      teamSubtitle: 'Rencontrez les artistes et spécialistes talentueux qui donnent vie à votre vision beauté',
      joinOurTeam: 'Rejoignez Notre Équipe',
      joinOurTeamText: 'Êtes-vous passionné par la beauté et l\'excellence ? Nous recherchons toujours des personnes talentueuses pour rejoindre notre famille.',
      viewOpenPositions: 'Voir les Postes Ouverts',
      teamUpdating: 'Les informations de notre équipe sont en cours de mise à jour. Revenez bientôt !',
      unableToLoadTeam: 'Impossible de charger les membres de l\'équipe',
      leadStylist: 'Styliste Principal & Manager',
      seniorSpecialist: 'Spécialiste Senior',
      specialist: 'Spécialiste',
      manager: 'Manager',
      teamMember: 'Membre de l\'Équipe',

      // Contact Page
      contactUsTitle: 'CONTACTEZ-NOUS',
      contactSubtitle: 'Entrez en contact avec notre équipe',
      sendUsMessage: 'Envoyez-nous un message',
      nameLabel: 'NOM',
      yourNamePlaceholder: 'Votre nom',
      emailLabel: 'EMAIL',
      emailPlaceholder: 'votre@email.com',
      messageLabel: 'MESSAGE',
      messagePlaceholder: 'Comment pouvons-nous vous aider ?',
      sendMessage: 'ENVOYER LE MESSAGE',
      addressLabel: 'Adresse',
      phoneLabel: 'Téléphone',
      hoursLabel: 'Horaires',
      businessHours: 'Tous les jours: 10h00 - 23h00',

      // Services Browsing
      browseServicesHeading: 'PARCOURIR LES SERVICES',
      browseServicesSubtitle: 'Services de beauté premium pour les soins à domicile',
      searchProducts: 'Rechercher des produits...',
      allCategories: 'Tous',
      hairCareCategory: 'Soins Capillaires',
      skinCareCategory: 'Soins de la Peau',
      nailCareShop: 'Soins des Ongles',
      makeupCategory: 'Maquillage',
      toolsCategory: 'Outils',
      bodyCareCategory: 'Soins du Corps',
      noProductsFound: 'Aucun produit trouvé',
      tryDifferentSearch: 'Essayez une autre catégorie ou terme de recherche',
      featured: 'En Vedette',
      lowStock: 'Stock Faible',
      inStock: 'En Stock',
      leftInStock: 'restant',
      addToCart: 'Ajouter au Panier',
      outOfStock: 'Rupture de Stock',
      addedToCart: 'Ajouté au panier',
      addedToCartDesc: 'a été ajouté à votre panier.',
      removedFromWishlist: 'Retiré de la liste de souhaits',
      addedToWishlist: 'Ajouté à la liste de souhaits',
      productRemovedWishlist: 'Le produit a été retiré de votre liste de souhaits.',
      productAddedWishlist: 'Le produit a été ajouté à votre liste de souhaits.',
      loadingProducts: 'Chargement des produits...',
      customerReviews: 'Avis Clients',
      noReviewsYet: 'Pas encore d\'avis. Soyez le premier à donner votre avis !',
      verified: 'Vérifié',
      foundHelpful: 'ont trouvé cela utile',
      ingredients: 'Ingrédients',
      howToUse: 'Comment Utiliser',
      reviews: 'avis',
      noProductsForSearch: 'Aucun produit trouvé pour',
      sizeLabel: 'Taille :',
      skuLabel: 'UGS :',
      failedToLoadProducts: 'Échec du chargement des produits',

      // Blog Page
      blogTitle: 'BLOG',
      blogSubtitle: 'Conseils beauté et avis d\'experts',
      noBlogPosts: 'Aucun article de blog trouvé dans cette catégorie.',
      byAuthor: 'Par',

      // VideoHero
      exploreServices: 'Découvrir les Services',
      professionalBeautyServices: 'Services de beauté professionnels dans une atmosphère élégante',

      // Services Page
      servicesTitle: 'SERVICES',
      servicesSubtitle: 'Offrez-vous notre sélection de soins de luxe',
      searchServicesPlaceholder: 'Rechercher des services... (ex: \'massage relaxant\' ou \'coloration\')',
      noServicesFound: 'Aucun service trouvé correspondant à',
      tryDifferentTerm: 'Essayez un autre terme de recherche',
      preview: 'Aperçu',
      seeTransformation: 'Voir la transformation',
      beforeTreatment: 'Avant le Traitement',
      afterTreatment: 'Après le Traitement',
      bookThisService: 'Réserver ce Service',
      minutes: 'minutes',

      // AnimatedMenu (Hormozi-optimized: value-driven, action-oriented, benefit-focused)
      menuServices: 'PARCOURIR LES SERVICES',
      menuPackages: 'OFFRES SPÉCIALES',
      menuBooking: 'RÉSERVER MAINTENANT',
      menuMyAppointments: 'MES RÉSERVATIONS',
      menuMembership: 'ADHÉSION VIP',
      menuShop: 'PARCOURIR LES SERVICES',
      menuBlog: 'CONSEILS BEAUTÉ',
      menuCareers: 'REJOIGNEZ NOTRE ÉQUIPE',
      menuReferrals: 'GAGNEZ DES RÉCOMPENSES',
      menuAbout: 'NOTRE HISTOIRE',
      menuContact: 'CONTACTEZ-NOUS',
      // Menu sub-items
      hairServices: 'Services Capillaires',
      massageTherapy: 'Massothérapie',
      tattooArt: 'Art du Tatouage',
      allPackages: 'Tous les Forfaits',
      menPackages: 'Pour Hommes',
      bridalPackages: 'Pour Mariées',
      groupPackages: 'Groupes et Fêtes',
      viewAllAppointments: 'Voir Tout',
      upcomingAppointments: 'À Venir',
      membershipPlans: 'Voir les Plans',
      memberBenefits: 'Avantages Membres',
      referFriend: 'Recommander un Ami',
      myRewards: 'Mes Récompenses',
      bookAppointmentMenu: 'Prendre Rendez-vous',
      groupBooking: 'Réservation de Groupe',
      beautyTools: 'Outils de Beauté',
      beautyTips: 'Conseils Beauté',
      styleGuides: 'Guides de Style',
      productReviews: 'Avis sur les Produits',
      currentOpenings: 'Postes Actuels',
      applyNow: 'Postuler Maintenant',
      ourStoryMenu: 'Notre Histoire',
      hoursOfOperation: 'Heures d\'Ouverture',
      getDirections: 'Obtenir l\'Itinéraire',
      callUs: 'Appelez-nous',
      faq: 'FAQ',

      // Accessibility
      accessibility: 'Accessibilité',
      theme: 'Thème',
      darkTheme: 'Sombre',
      lightTheme: 'Clair',
      systemTheme: 'Système',
      highContrastTheme: 'Contraste Élevé',
      fontSize: 'Taille de Police',
      small: 'Petit',
      medium: 'Moyen',
      large: 'Grand',
      extraLarge: 'Très Grand',
      language: 'Langue',
      english: 'Anglais',
      french: 'Français',
      spanish: 'Espagnol',

      // Common UI
      close: 'Fermer',
      back: 'Retour',
      menu: 'Menu',
      all: 'Tous',
      salonAndSpa: 'Salon et Spa',
    }
  },
  es: {
    translation: {
      // Navigation
      login: 'INICIAR SESIÓN',
      logout: 'CERRAR SESIÓN',
      welcome: 'BIENVENIDO',

      // Auth
      signUp: 'REGISTRARSE',
      loginTitle: 'INICIAR SESIÓN',
      signUpTitle: 'REGISTRARSE',
      accessAccount: 'Accede a tu cuenta',
      createAccount: 'Crea tu cuenta',
      fullName: 'NOMBRE COMPLETO',
      firstName: 'NOMBRE',
      lastName: 'APELLIDO',
      birthdate: 'FECHA DE NACIMIENTO',
      email: 'EMAIL',
      password: 'CONTRASEÑA',
      yourName: 'Tu nombre',
      yourFirstName: 'Tu nombre',
      yourLastName: 'Tu apellido',
      yourEmail: 'tu@email.com',
      passwordPlaceholder: '••••••••',
      loading: 'CARGANDO...',
      loginBtn: 'INICIAR SESIÓN',
      signUpBtn: 'REGISTRARSE',
      noAccount: '¿No tienes cuenta? Regístrate',
      haveAccount: '¿Ya tienes cuenta? Inicia sesión',
      welcomeBack: '¡Bienvenido de vuelta!',
      loginSuccess: 'Has iniciado sesión correctamente.',
      accountCreated: '¡Cuenta creada!',
      checkEmail: 'Por favor revisa tu email para verificar tu cuenta.',

      // Footer
      services: 'SERVICIOS',
      company: 'EMPRESA',
      support: 'SOPORTE',
      followUs: 'SÍGUENOS',
      hair: 'Cabello',
      nails: 'Uñas',
      skin: 'Piel',
      massage: 'Masaje',
      tattoo: 'Tatuaje',
      piercing: 'Piercing',
      aboutUs: 'Sobre Nosotros',
      careers: 'Carreras',
      blog: 'Blog',
      press: 'Prensa',
      contact: 'Contacto',
      faqs: 'Preguntas Frecuentes',
      privacy: 'Privacidad',
      terms: 'Términos',
      privacyPolicy: 'Política de Privacidad',
      termsOfService: 'Términos de Servicio',
      cookiePolicy: 'Política de Cookies',
      copyright: '© 2025 Zavira Salon & Spa. Todos los derechos reservados.',

      // Other common
      bookAppointment: 'RESERVAR CITA',
      reserveExperience: 'Reserva tu experiencia lujosa',
      ourServices: 'Nuestros Servicios',
      experienceLuxury: 'Experimenta el lujo y la excelencia',
      viewAllServices: 'Ver Todos los Servicios',
      browseServices: 'Explorar servicios',
      // Services
      hairStyling: 'Estilismo Capilar',
      hairStylingDesc: 'Cortes premium, coloración y tratamientos',
      nailCare: 'Cuidado de Uñas',
      nailCareDesc: 'Manicuras, pedicuras y nail art',
      skincare: 'Cuidado de la Piel',
      skincareDesc: 'Tratamientos faciales, cuidados y rejuvenecimiento',
      massageService: 'Masaje',
      massageDesc: 'Masaje de relajación y terapéutico',
      tattooService: 'Tatuaje',
      tattooDesc: 'Arte corporal y obras personalizadas',
      piercingService: 'Piercing',
      piercingDesc: 'Servicios profesionales de piercing',

      // Products
      luxuryHairSerum: 'Suero Capilar de Lujo',
      premiumFaceCream: 'Crema Facial Premium',
      nailPolishSet: 'Set de Esmaltes de Uñas',
      hydratingShampoo: 'Champú Hidratante',
      antiAgingSerum: 'Suero Antienvejecimiento',
      makeupBrushSet: 'Set de Pinceles de Maquillaje',
      hairCare: 'Cuidado del Cabello',
      skinCare: 'Cuidado de la Piel',
      nailCareCategory: 'Cuidado de Uñas',
      makeup: 'Maquillaje',

      // Reviews section
      whatOurClientsSay: 'Lo Que Dicen Nuestros Clientes',
      testimonialsFromGuests: 'Testimonios de nuestros valiosos huéspedes',

      // Review texts
      reviewSarah: '¡Experiencia absolutamente impresionante! La atención al detalle es incomparable.',
      reviewMichael: 'El mejor salón de la ciudad. El personal es profesional y el ambiente es lujoso.',
      reviewEmma: 'Me siento como una reina cada vez que visito. ¡Altamente recomendado!',
      reviewDavid: 'Servicio y resultados excepcionales. Vale cada centavo.',
      reviewSophie: 'Los tratamientos de spa son celestiales. Un verdadero escape de la vida cotidiana.',

      // Booking
      bookAppointmentTitle: 'RESERVAR CITA',
      selectService: 'SELECCIONAR SERVICIO',
      selectStylist: 'SELECCIONAR ESTILISTA',
      selectDateTime: 'SELECCIONAR FECHA Y HORA',
      contactInfo: 'INFORMACIÓN DE CONTACTO',
      confirmBooking: 'CONFIRMAR RESERVA',
      availableTimeSlots: 'HORARIOS DISPONIBLES',
      specialRequests: 'SOLICITUDES ESPECIALES',
      bookingSummary: 'Resumen de la Reserva',
      payment: 'Pago',
      payWithCard: 'O paga con tarjeta durante tu visita',
      bookingConfirmed: '¡Reserva confirmada!',
      bookingSuccessGuest: 'Tu cita ha sido programada. Nos pondremos en contacto contigo pronto para confirmar los detalles.',
      bookingSuccessUser: 'Tu cita ha sido programada exitosamente.',
      error: 'Error',
      fillRequiredFields: 'Por favor completa todos los campos requeridos.',
      phoneNumber: 'NÚMERO DE TELÉFONO',
      location: 'UBICACIÓN',
      fullNameLabel: 'NOMBRE COMPLETO',
      emailOptional: 'EMAIL (Opcional)',
      emailRequired: 'EMAIL',
      phoneOptional: 'TELÉFONO (Opcional)',
      downtownSalon: 'Salón Centro',
      uptownSpa: 'Spa Zona Alta',
      westsideStudio: 'Estudio Oeste',
      eastsideLounge: 'Lounge Este',
      airportLocation: 'Ubicación Aeropuerto',
      service: 'Servicio:',
      stylist: 'Estilista:',
      date: 'Fecha:',
      time: 'Hora:',
      name: 'Nombre:',
      phone: 'Teléfono:',
      locationLabel: 'Ubicación:',
      previous: 'Anterior',
      next: 'Siguiente',
      confirmBookingBtn: 'CONFIRMAR RESERVA',
      bookingInProgress: 'RESERVANDO...',

      // AI Recommendations
      recommendedForYou: 'Recomendado para Ti',
      basedOnPreferences: 'Basado en tus preferencias e historial de reservas',
      whyRecommended: 'Por qué recomendado',
      bookNow: 'Reservar Ahora',
      viewDetails: 'Ver Detalles',

      // Calendar Sync
      syncToCalendar: 'Sincronizar con Calendario',
      addToGoogleCalendar: 'Agregar a Google Calendar',
      addToOutlook: 'Agregar a Outlook',
      calendarSyncSuccess: '¡Cita agregada a tu calendario!',
      calendarSyncError: 'Error al agregar al calendario. Por favor intenta manualmente.',

      // Real-time updates
      liveAvailability: 'Disponibilidad en Vivo',
      updating: 'Actualizando...',
      slotsAvailable: 'espacios disponibles',
      fullyBooked: 'Completamente reservado',
      lastUpdated: 'Última actualización',
      justNow: 'ahora mismo',
      minutesAgo: 'minutos atrás',

      // About Page
      aboutUsTitle: 'SOBRE NOSOTROS',
      aboutSubtitle: 'Donde el lujo se encuentra con la excelencia',
      ourStory: 'Nuestra Historia',
      ourStoryText: 'Fundado en 2020, Zavira Salon & Spa se ha convertido en el destino principal para tratamientos de belleza y bienestar de lujo. Nuestro compromiso con la excelencia y atención al detalle nos ha convertido en la elección de clientes exigentes que buscan solo lo mejor.',
      ourPhilosophy: 'Nuestra Filosofía',
      ourPhilosophyText: 'Creemos que la belleza es una forma de arte, y cada cliente merece una experiencia personalizada. Nuestro equipo de estilistas y terapeutas expertos está apasionado por resaltar tu belleza natural mientras proporcionamos un santuario para la relajación y el rejuvenecimiento.',
      whyChooseUs: 'Por Qué Elegirnos',
      whyChooseUs1: 'Profesionales de clase mundial con años de experiencia',
      whyChooseUs2: 'Productos premium de las mejores marcas de lujo',
      whyChooseUs3: 'Instalaciones de última generación en un ambiente elegante',
      whyChooseUs4: 'Servicio personalizado adaptado a tus necesidades',

      // Team Page
      ourTeam: 'Nuestro Equipo',
      teamSubtitle: 'Conoce a los artistas y especialistas talentosos que dan vida a tu visión de belleza',
      joinOurTeam: 'Únete a Nuestro Equipo',
      joinOurTeamText: '¿Eres apasionado por la belleza y la excelencia? Siempre estamos buscando personas talentosas para unirse a nuestra familia.',
      viewOpenPositions: 'Ver Posiciones Abiertas',
      teamUpdating: 'La información de nuestro equipo se está actualizando. ¡Vuelve pronto!',
      unableToLoadTeam: 'No se pueden cargar los miembros del equipo',
      leadStylist: 'Estilista Principal y Gerente',
      seniorSpecialist: 'Especialista Senior',
      specialist: 'Especialista',
      manager: 'Gerente',
      teamMember: 'Miembro del Equipo',

      // Contact Page
      contactUsTitle: 'CONTÁCTANOS',
      contactSubtitle: 'Ponte en contacto con nuestro equipo',
      sendUsMessage: 'Envíanos un mensaje',
      nameLabel: 'NOMBRE',
      yourNamePlaceholder: 'Tu nombre',
      emailLabel: 'EMAIL',
      emailPlaceholder: 'tu@email.com',
      messageLabel: 'MENSAJE',
      messagePlaceholder: '¿Cómo podemos ayudarte?',
      sendMessage: 'ENVIAR MENSAJE',
      addressLabel: 'Dirección',
      phoneLabel: 'Teléfono',
      hoursLabel: 'Horarios',
      businessHours: 'Diario: 10:00 AM - 11:00 PM',

      // Services Browsing
      browseServicesHeading: 'EXPLORAR SERVICIOS',
      browseServicesSubtitle: 'Servicios de belleza premium para el cuidado en casa',
      searchProducts: 'Buscar productos...',
      allCategories: 'Todos',
      hairCareCategory: 'Cuidado del Cabello',
      skinCareCategory: 'Cuidado de la Piel',
      nailCareShop: 'Cuidado de Uñas',
      makeupCategory: 'Maquillaje',
      toolsCategory: 'Herramientas',
      bodyCareCategory: 'Cuidado Corporal',
      noProductsFound: 'No se encontraron productos',
      tryDifferentSearch: 'Prueba una categoría o término de búsqueda diferente',
      featured: 'Destacado',
      lowStock: 'Stock Bajo',
      inStock: 'En Stock',
      leftInStock: 'restante',
      addToCart: 'Añadir al Carrito',
      outOfStock: 'Agotado',
      addedToCart: 'Añadido al carrito',
      addedToCartDesc: 'ha sido añadido a tu carrito.',
      removedFromWishlist: 'Eliminado de la lista de deseos',
      addedToWishlist: 'Añadido a la lista de deseos',
      productRemovedWishlist: 'El producto ha sido eliminado de tu lista de deseos.',
      productAddedWishlist: 'El producto ha sido añadido a tu lista de deseos.',
      loadingProducts: 'Cargando productos...',
      customerReviews: 'Reseñas de Clientes',
      noReviewsYet: 'Aún no hay reseñas. ¡Sé el primero en opinar!',
      verified: 'Verificado',
      foundHelpful: 'encontraron esto útil',
      ingredients: 'Ingredientes',
      howToUse: 'Cómo Usar',
      reviews: 'reseñas',
      noProductsForSearch: 'No se encontraron productos para',
      sizeLabel: 'Tamaño:',
      skuLabel: 'SKU:',
      failedToLoadProducts: 'Error al cargar los productos',

      // Blog Page
      blogTitle: 'BLOG',
      blogSubtitle: 'Consejos de belleza y asesoramiento experto',
      noBlogPosts: 'No se encontraron artículos en esta categoría.',
      byAuthor: 'Por',

      // VideoHero
      exploreServices: 'Explorar Servicios',
      professionalBeautyServices: 'Servicios de belleza profesionales en un ambiente elegante',

      // Services Page
      servicesTitle: 'SERVICIOS',
      servicesSubtitle: 'Disfruta de nuestra selección de tratamientos de lujo',
      searchServicesPlaceholder: 'Buscar servicios... (ej: \'masaje relajante\' o \'color de cabello\')',
      noServicesFound: 'No se encontraron servicios que coincidan con',
      tryDifferentTerm: 'Prueba un término de búsqueda diferente',
      preview: 'Vista Previa',
      seeTransformation: 'Ver la transformación',
      beforeTreatment: 'Antes del Tratamiento',
      afterTreatment: 'Después del Tratamiento',
      bookThisService: 'Reservar Este Servicio',
      minutes: 'minutos',

      // AnimatedMenu (Hormozi-optimized: value-driven, action-oriented, benefit-focused)
      menuServices: 'EXPLORAR SERVICIOS',
      menuPackages: 'OFERTAS ESPECIALES',
      menuBooking: 'RESERVAR AHORA',
      menuMyAppointments: 'MIS RESERVAS',
      menuMembership: 'MEMBRESÍA VIP',
      menuShop: 'EXPLORAR SERVICIOS',
      menuBlog: 'CONSEJOS DE BELLEZA',
      menuCareers: 'ÚNETE AL EQUIPO',
      menuReferrals: 'GANA RECOMPENSAS',
      menuAbout: 'NUESTRA HISTORIA',
      menuContact: 'CONTÁCTANOS',
      // Menu sub-items
      hairServices: 'Servicios de Cabello',
      massageTherapy: 'Masoterapia',
      tattooArt: 'Arte del Tatuaje',
      allPackages: 'Todos los Paquetes',
      menPackages: 'Para Hombres',
      bridalPackages: 'Para Novias',
      groupPackages: 'Grupos y Fiestas',
      viewAllAppointments: 'Ver Todas',
      upcomingAppointments: 'Próximas',
      membershipPlans: 'Ver Planes',
      memberBenefits: 'Beneficios de Miembros',
      referFriend: 'Recomendar un Amigo',
      myRewards: 'Mis Recompensas',
      bookAppointmentMenu: 'Reservar Cita',
      groupBooking: 'Reserva Grupal',
      beautyTools: 'Herramientas de Belleza',
      beautyTips: 'Consejos de Belleza',
      styleGuides: 'Guías de Estilo',
      productReviews: 'Reseñas de Productos',
      currentOpenings: 'Vacantes Actuales',
      applyNow: 'Aplicar Ahora',
      ourStoryMenu: 'Nuestra Historia',
      hoursOfOperation: 'Horario de Atención',
      getDirections: 'Obtener Direcciones',
      callUs: 'Llámanos',
      faq: 'Preguntas Frecuentes',

      // Accessibility
      accessibility: 'Accesibilidad',
      theme: 'Tema',
      darkTheme: 'Oscuro',
      lightTheme: 'Claro',
      systemTheme: 'Sistema',
      highContrastTheme: 'Alto Contraste',
      fontSize: 'Tamaño de Fuente',
      small: 'Pequeño',
      medium: 'Mediano',
      large: 'Grande',
      extraLarge: 'Extra Grande',
      language: 'Idioma',
      english: 'Inglés',
      french: 'Francés',
      spanish: 'Español',

      // Common UI
      close: 'Cerrar',
      back: 'Atrás',
      menu: 'Menú',
      all: 'Todos',
      salonAndSpa: 'Salón y Spa',
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'zavira-language',
    },
  });

export default i18n;
